import type { DiffItemRef } from '~/api/types'
import { Badge } from '~/components/ui/badge'
import { Card } from '~/components/ui/card'
import { EmptyTab, ItemIdentity } from './DiffParts'

// ── 삭제(자동 반영 안 함, 선택은 경고만) ──────────────────────────────────────

export function RemovedList({
    items,
    selected,
    onToggle,
}: {
    items: DiffItemRef[]
    selected: Set<string>
    onToggle: (id: string) => void
}) {
    if (items.length === 0) {
        return <EmptyTab text='삭제된 항목이 없어요.' />
    }
    return (
        <div className='space-y-3'>
            <div className='bg-destructive/10 border-destructive/30 rounded-[var(--radius)] border p-3'>
                <p className='text-destructive text-sm'>
                    현재 카탈로그에는 있으나 새 책자에는 없는 항목이에요. 기존
                    평가가 이 항목을 참조할 수 있어{' '}
                    <strong>자동 반영하지 않습니다</strong>. 선택해도 일괄 반영
                    대상에 포함되지 않으며, 삭제는 운영 검토 후 별도 진행하세요.
                </p>
            </div>
            {items.map((item, i) => {
                const id = item.id
                const checked = id ? selected.has(id) : false
                return (
                    <Card
                        key={item.id ?? `${item.part}-${item.itemNumber}-${i}`}
                        className='border-destructive/40 flex items-center gap-3 border-l-4 p-3'>
                        <input
                            type='checkbox'
                            className='size-4 accent-[var(--destructive)]'
                            checked={checked}
                            disabled={!id}
                            onChange={() => id && onToggle(id)}
                        />
                        <div className='min-w-0 flex-1'>
                            <ItemIdentity item={item} />
                        </div>
                        {checked ? (
                            <Badge tone='danger'>반영 제외(경고)</Badge>
                        ) : null}
                    </Card>
                )
            })}
        </div>
    )
}
